import store from "../store";

export default {
  openPdfOnWeb(data) {
    let blob = new Blob([data], { type: "application/pdf" });
    let url = window.URL.createObjectURL(blob);
    window.open(url, "_blank");
  },

  downloadFileBlob(data, fileName) {
    const blob = new Blob([data], { type: this.getMimeType(fileName) });
    const url = window.URL.createObjectURL(blob);

    this.downloadFile(url, fileName);

    // Rilascio la memoria dopo un po' (non subito, altrimenti Safari non fa in tempo)
    setTimeout(() => window.URL.revokeObjectURL(url), 60000);
  },

  getMimeType(fileName) {
    const ext = (fileName.split(".").pop() || "").toLowerCase();
    const map = {
      pdf: "application/pdf",
      doc: "application/msword",
      docx:
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      xls: "application/vnd.ms-excel",
      xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ppt: "application/vnd.ms-powerpoint",
      pptx:
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      txt: "text/plain",
      csv: "text/csv",
      zip: "application/zip",
      jpg: "image/jpeg",
      jpeg: "image/jpeg",
      png: "image/png",
      gif: "image/gif",
    };
    return map[ext] || "application/octet-stream";
  },

  isIOS() {
    return (
      /iP(hone|ad|od)/.test(navigator.userAgent) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1) // iPadOS si presenta come Mac
    );
  },

  /*   downloadFile(url, fileName) {
    var element = document.createElement("a");
    element.href = url;

    element.setAttribute("download", fileName);

    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }, */

  downloadFile(url, fileName) {
    const element = document.createElement("a");
    element.href = url;
    element.style.display = "none";

    element.setAttribute("download", fileName);

    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  },

  createBlobPdf(data) {
    const blob = new Blob([data], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);

    if (this.isIOS()) {
      this.downloadFile(url, "documento.pdf");
    } else {
      window.open(url);
    }

    setTimeout(() => URL.revokeObjectURL(url), 60000);
  },

  getFileName(path) {
    return path.replace(/^.*[\\\/]/, "");
  },

  formatCurrency(num) {
    if (isNaN(num)) return 0;

    const formatter = new Intl.NumberFormat("it-IT", {
      style: "currency",
      currency: "EUR",
    });

    return formatter.format(num);
  },
};
